{
	"title": "Imprint",
	"backTitle": "Back",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Germany"
		},
		"contact": {
			"telephone": "Telephone: +49 6221 481-0",
			"telefax": "Telefax: +49 6221 481-13553",
			"email": "Email: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Registered Office of the company: Heidelberg",
			"commercialRegister": "Commercial Register: Mannheim, HRB 741878",
			"managingDirectors": "Managing Directors:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
